import { IAttendingPhysicianCreate } from '~/services/api/attendingPhysicians/types';

export const createInitialValues = (): IAttendingPhysicianCreate => ({
  name: '',
  specialty: '',
  phone: '',
  fax: '',
});

export default {};
